import { Locale } from '../types';

import frenchFormats from './fr/date-formats.json';
import englishFormats from './en/date-formats.json';
import germanFormats from './de/date-formats.json';

export type DateFormat =
  | 'date_default'
  | 'date_iso_8601'
  | 'date_default_short'
  | 'date_day_short'
  | 'date_day_month'
  | 'date_day_month_short'
  | 'date_day_month_year'
  | 'date_day_month_year_short'
  | 'date_month'
  | 'date_month_short'
  | 'date_month_year'
  | 'date_month_year_short'
  | 'date_month_year_shorter'
  | 'date_weekday'
  | 'date_weekday_short'
  | 'date_weekday_plural'
  | 'date_weekday_plural_at'
  | 'date_weekday_day_month'
  | 'date_weekday_day_month_short'
  | 'date_weekday_day_month_short_at'
  | 'date_weekday_day_month_year'
  | 'date_weekday_day_month_year_short'
  | 'date_weekday_day_month_year_short_rfc'
  | 'date_year';

export type DateTimeFormat =
  | 'datetime_weekday_at_time'
  | 'datetime_weekday_day_month_year_at_time'
  | 'datetime_weekday_day_month_at_time'
  | 'datetime_weekday_day_month_at_time_short'
  | 'datetime_weekday_long_day_long_month_at_time'
  | 'datetime_date_standard_dash_time'
  | 'datetime_day_month_at_time'
  | 'datetime_short_date_at_time'
  | 'datetime_date_standard_at_time'
  | 'datetime_timestamp'
  | 'datetime_api_timestamp'
  | 'datetime_rfc_2822';

export type DateLocaleFormats = Record<DateFormat | DateTimeFormat, string>;

const DATE: Record<string, DateFormat> = {
  DEFAULT: 'date_default',
  ISO_8601: 'date_iso_8601',
  DEFAULT_SHORT: 'date_default_short',
  DAY_SHORT: 'date_day_short',
  DAY_MONTH: 'date_day_month',
  DAY_MONTH_SHORT: 'date_day_month_short',
  DAY_MONTH_YEAR: 'date_day_month_year',
  DAY_MONTH_YEAR_SHORT: 'date_day_month_year_short',
  MONTH: 'date_month',
  MONTH_YEAR: 'date_month_year',
  MONTH_YEAR_SHORT: 'date_month_year_short',
  MONTH_YEAR_SHORTER: 'date_month_year_shorter',
  WEEKDAY: 'date_weekday',
  WEEKDAY_SHORT: 'date_weekday_short',
  WEEKDAY_PLURAL: 'date_weekday_plural',
  WEEKDAY_PLURAL_AT: 'date_weekday_plural_at',
  WEEKDAY_DAY_MONTH: 'date_weekday_day_month',
  WEEKDAY_DAY_MONTH_SHORT: 'date_weekday_day_month_short',
  WEEKDAY_DAY_MONTH_SHORT_AT: 'date_weekday_day_month_short_at',
  WEEKDAY_DAY_MONTH_YEAR: 'date_weekday_day_month_year',
  WEEKDAY_DAY_MONTH_YEAR_SHORT: 'date_weekday_day_month_year_short',
  YEAR: 'date_year',
};

const DATETIME: Record<string, DateTimeFormat> = {
  DAY_MONTH_AT_TIME: 'datetime_day_month_at_time',
  WEEKDAY_AT_TIME: 'datetime_weekday_at_time',
  WEEKDAY_DAY_MONTH_YEAR_AT_TIME: 'datetime_weekday_day_month_year_at_time',
  WEEKDAY_DAY_MONTH_AT_TIME: 'datetime_weekday_day_month_at_time',
  WEEKDAY_DAY_MONTH_AT_TIME_SHORT: 'datetime_weekday_day_month_at_time_short',
  WEEKDAY_LONG_DAY_LONG_MONTH_AT_TIME: 'datetime_weekday_long_day_long_month_at_time',
  DATE_STANDARD_DASH_TIME: 'datetime_date_standard_dash_time',
  SHORT_DATE_AT_TIME: 'datetime_short_date_at_time',
  DATE_STANDARD_AT_TIME: 'datetime_date_standard_at_time',
  TIMESTAMPS: 'datetime_timestamp',
  API_TIMESTAMP: 'datetime_api_timestamp',
};

export const FORMATS = {
  DATE,
  DATETIME,
};

export const DATE_FORMATS_BY_LOCALE: Record<Locale, DateLocaleFormats> = {
  fr: frenchFormats,
  'fr-CH': frenchFormats,
  // TODO I18N: Verify German formats with product
  de: germanFormats,
  'de-AT': germanFormats,
  'de-CH': germanFormats,
  en: englishFormats,
};
